import './QuestionDetails.sass';

import React from 'react';
import { Col, Row } from 'react-bootstrap';
import ModalImage from 'react-modal-image';
import { Button } from 'reactstrap';
import _ from 'underscore';

import ContentIssues, {
  getContentIssuesLabel,
} from '../../../../commonComponents/ContentIssues/ContentIssues';
import DropDown from '../../../../commonComponents/DropDown/DropDown';
import SimpleConfirmation from '../../../../commonComponents/Modals/SimpleConfirmation/SimpleConfirmation';
import SpellCheckPreview from '../../../../commonComponents/SpellCheckPreview/SpellCheckPreview';
import Spinner from '../../../../commonComponents/Spinner/Spinner';
import WYSIWYG from '../../../../commonComponents/WYSIWYG/WYSIWYG';
import {
  dateOptions,
  localeDateName,
  timeOptions,
} from '../../../../constants/date';
import {
  getCharacterStatus,
  getTextCharacterCount,
  validateCharacterLimit,
} from '../../../../utilities/characterCounter';
import {
  endsWithQuestionMark,
  getAnswerContentErrorMessages,
  getDuplicateAnswers,
  getQuestionContentErrorMessages,
  getTextContentErrorMessages,
} from '../../../../utilities/questionValidation';
import { sanitizeRichText } from '../../../../utilities/reRenderFormulas';
import Footer from '../../../Footer';
import { AI_TASK_STATUS } from '../Header/constants/constants';
import { QuestionAudioActions } from '../QuestionAudioActions/QuestionAudioActions';
import QuestionHistoryModal from '../QuestionHistory/ModalQuestionHistory';
import { StudentAgentAnswer } from '../StudentAgentAnswer/StudentAgentAnswer';
import UploadInput from '../UploadInput/UploadInput';
import { AnswerTextArea } from './componentes/AnswerTextArea';
import { QuestionExtraInformation } from './componentes/QuestionExtraInformation';
import { QuestionTextArea } from './componentes/QuestionTextArea';

const NotificationSystem = require('react-notification-system');

const orderOptions = [
  { value: 1, text: 'A' },
  { value: 2, text: 'B' },
  { value: 3, text: 'C' },
  { value: 4, text: 'D' },
];

export default class QuestionDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      question: this.getCopyOfObject(this.props.defaultQuestion),
      isFlashCardMode: false,
      spellCheckOn: false,
      substantialChangesQuestion: false,
      substantialChangesAnswer: false,
      customPrompt: '',
      addCustom: false,
      customText: '',
      createCustom: false,
      value: false,
      userCustomPrompts: this.props.userCustomPrompts,
      customPromptSelect: '',
      errorCustom: false,
    };

    this.change;
    this._notificationSystem = null;
  }

  UNSAFE_componentWillMount() {
    let hasGPTPermissions = false;

    if (this.props.user?.roles) {
      hasGPTPermissions = !!(
        (Array.isArray(this.props.user.roles) &&
          this.props.user.roles.some(
            (role) => role?.name === 'Create GPT questions',
          )) ||
        this.props.user.roles?.name === 'Create GPT questions' ||
        this.props.user.isSuperAdmin
      );
    }

    if (this.props.question?.id) {
      let question = this.getCopyOfObject(this.props.question);
      question = this.removeEscapeCharactersFromQuestion(question);
      this.setState({
        question: this.getCopyOfObject(this.props.question),
        isFlashCardMode: !this.props.question.multipleOptionMode,
      });
    }
    if (this.props.isRefreshForm) {
      this.refreshForm();
    }

    if (this.props.assignment?.chapter && hasGPTPermissions) {
      this.props.getUserCustomPrompt(this.props.assignment.chapter.id);
      this.setState({ loadCustomPrompts: true });
    }
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
    this.initializeListener();
    this.props.getCommonAiAdminFeedbackTemplates();
    this.props.getSpellCheckWhitelistWords();
  }

  componentDidUpdate(prevProps, prevState) {
    const hasGPTPermissions = Array.isArray(this.props.user?.roles)
      ? this.props.user.roles
          .map((role) => role.name)
          .includes('Create GPT questions') || this.props.user.isSuperAdmin
      : this.props.user?.roles?.name === 'Create GPT questions' ||
        this.props.user?.isSuperAdmin;

    if (
      prevProps.userCustomPrompts &&
      this.props.userCustomPrompts &&
      hasGPTPermissions
    ) {
      if (
        prevProps.userCustomPrompts.length !==
          this.props.userCustomPrompts.length &&
        this.props.chapter?.id
      ) {
        this.props.getUserCustomPrompt(this.props.chapter.id);
      }
    }

    if (
      (Array.isArray(this.props.userCustomPrompts) && !this.state.value) ||
      prevProps.question !== this.props.question
    ) {
      // Check for userCustomPrompts. If create, keep last prompt; if editquestion, keep the created custom.

      let createCustom = this.state.createCustom;
      let customSelect = this.state.userCustomPrompts?.length
        ? this.state.userCustomPrompts[0]
        : [];
      let textCustom = this.state.customText;
      let addCustom = this.state.addCustom;

      if (this.props.question) {
        if (
          this.props.question?.originalResponse &&
          !this.props.question.originalResponse.adminUser
        ) {
          this.props.setIsCreatingAiQuestion(false);
        }
        if (this.props.userCustomPrompts?.length) {
          this.props.userCustomPrompts.forEach((custom) => {
            if (this.props.question.originalResponse) {
              if (
                custom.id === this.props.question.originalResponse.ai_prompt
              ) {
                customSelect = custom;
                textCustom = custom.prompt.replace('USER_PROMPT ', '');
                createCustom = false;
                addCustom = true;
              }
            }
          });
        }
      } else {
        customSelect = this.state.userCustomPrompts?.length
          ? this.state.userCustomPrompts[0]
          : [];
        createCustom = false;
        textCustom = '';
        addCustom = false;
      }

      this.setState({
        value: true,
        customText: textCustom,
        createCustom,
        customPromptSelect: customSelect,
        addCustom,
      });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const hasChanges = (question) =>
      !question.defaultQuestion ||
      getTextCharacterCount(question.text) > 0 ||
      question.notes > 0 ||
      question.answers
        .map((answer) => getTextCharacterCount(answer.text) > 0)
        .reduce((acc, curr) => acc || curr, false);

    if (nextProps.isRefreshForm) {
      this.refreshForm();
    }
    if (nextProps.isSaveQuestion === this.props.isSaveQuestion) {
      if (nextProps.question) {
        let question = { ...nextProps.question, updateEditorView: true };
        question = this.removeEscapeCharactersFromQuestion(question);
        this.setState({
          question,
          isFlashCardMode: !nextProps.question.multipleOptionMode,
          substantialChangesQuestion: nextProps.question.substantialChanges,
        });

        if (question.answers) {
          const correctAnswer = question.answers.filter(
            (answer) => answer.correct === true,
          );
          this.setState({
            substantialChangesAnswer:
              correctAnswer && correctAnswer[0]
                ? correctAnswer[0].substantialChanges
                : false,
          });
        }
      } else {
        if (!hasChanges(this.state.question)) {
          this.setState({
            question: this.getCopyOfObject(this.props.defaultQuestion),
            isFlashCardMode: false,
          });
        }
      }
    }

    if (nextProps.isSaveQuestion) {
      this.showConfirmModal();
      this.props.setIsSaveQuestion(); // this sets isSaveQuestion to false
    }
    if (
      (nextProps.question &&
        this.props.question &&
        nextProps.question.id !== this.props.question.id) ||
      (nextProps.question && !this.props.question)
    ) {
      this.setState({
        isFlashCardMode: !nextProps.question.multipleOptionMode,
        spellCheckOn: false,
      });
      this.props.loadPublishedQuestion(null);
    }
  }

  removeEscapeCharacters(text) {
    if (text) {
      return text.split('</p><p>').join('<br>');
    }
  }

  removeEscapeCharactersFromQuestion(question) {
    if (question.text) {
      question.text = this.removeEscapeCharacters(question.text);
    }
    if (question.notes) {
      question.notes = this.removeEscapeCharacters(question.notes);
    }
    if (question.flashQuestionText) {
      question.flashQuestionText = this.removeEscapeCharacters(
        question.flashQuestionText,
      );
    }
    if (question.flashQuestionNotes) {
      question.flashQuestionNotes = this.removeEscapeCharacters(
        question.flashQuestionNotes,
      );
    }
    if (question.answers) {
      question.answers = question.answers.map((ans) => {
        ans.text = this.removeEscapeCharacters(ans.text);
        return ans;
      });
    }

    return question;
  }

  _handleKeyDown = (button) => {
    const selectedButton = document.getElementsByClassName(`${button}`)[0];
    if (selectedButton) {
      selectedButton.click();
      const questionInput = document.getElementsByClassName(
        'TextArea BorderTextArea form-control',
      )[0];
      if (questionInput) {
        questionInput.focus();
      }
    }
    event.preventDefault();
  };

  initializeListener = () => {
    let pressed = true;
    document.addEventListener('keydown', (event) => {
      if (
        pressed &&
        event.ctrlKey &&
        event.shiftKey &&
        event.code === 'Enter'
      ) {
        pressed = false;
        this._handleKeyDown('btn-save-default');
      }
      if (pressed && event.ctrlKey && event.code === 'Enter') {
        pressed = false;
        this._handleKeyDown('btn-save-create');
      }
    });
    document.addEventListener('keyup', () => {
      pressed = true;
    });
  };

  refreshForm = () => {
    this.props.setIsRefreshForm(false);
    this.setState({
      question: this.getCopyOfObject(this.props.defaultQuestion),
      isFlashCardMode: false,
    });
  };

  onChangeFurtherReading = (content) => {
    const question = this.state.question;
    question.flashQuestionNotes = content;
    question.notes = content;
    question.updateEditorView = false;
    this.setState({ question });
  };

  onChangeQuestion = (value) => {
    const newQuestion = this.state.question;
    newQuestion.flashQuestionText = value;
    newQuestion.text = value;
    this.setState({ question: newQuestion });
  };

  onChangeAnswer = (text, answerId) => {
    const newQuestions = this.getCopyOfObject(this.state.question);
    let maxId = 0;
    let aux = 0;
    newQuestions.answers.sort((a, b) =>
      a.id > b.id ? 1 : b.id > a.id ? -1 : 0,
    );

    const correctAnswer = newQuestions.answers.filter((a) => a.correct)[0];
    if (correctAnswer) {
      newQuestions.redBorderA = false;
    }

    newQuestions.answers.forEach((nAnswer) => {
      if (nAnswer) {
        aux = nAnswer.id;
        if (aux > maxId) {
          maxId = aux;
        }
      }
    });
    if (answerId) {
      // the input is an answer

      let plus = 1;
      // check if not have answers
      if (newQuestions.answers.length < 1) {
        text = null;
        const template = {
          id: plus + maxId,
          correct: true,
          order: 0,
          text: '',
        };
        newQuestions.answers.push(template);
        plus++;
        for (let i = 1; i < 4; i++) {
          if (!newQuestions.answers[i]) {
            const answerTemplate = {
              id: plus + maxId,
              correct: false,
              order: 0,
              text: '',
            };
            newQuestions.answers.push(answerTemplate);
            plus++;
          }
        }
      }
      const index = newQuestions.answers.findIndex((x) => x.id === answerId);

      if (
        !correctAnswer ||
        (!this.isValidAnswerContent(correctAnswer) &&
          newQuestions.answers[index].id !== correctAnswer.id)
      ) {
        if (
          (newQuestions.answers[index - 1] &&
            !this.isValidAnswerContent(newQuestions.answers[index - 1])) ||
          (!newQuestions.answers[index - 1] &&
            newQuestions.answers[index].correct === false)
        ) {
          switch (index) {
            case 1:
              newQuestions.redBorderB = true;
              break;
            case 2:
              newQuestions.redBorderC = true;
              break;
            case 3:
              newQuestions.redBorderD = true;
              break;
            default:
              break;
          }
        } else {
          newQuestions.redBorderB = false;
          newQuestions.redBorderC = false;
          newQuestions.redBorderD = false;
        }
      }
      newQuestions.answers[index].text = text;
    }
    this.setState({ question: newQuestions });
  };

  onChangePageNumber = (event) => {
    const newQuestions = this.getCopyOfObject(this.state.question);
    newQuestions[event.target.name] = event.target.value;
    this.setState({ question: newQuestions });
  };

  optionIsSelected = (option) =>
    this.state.question.answers?.some(
      (answer) => answer.order === option.value,
    );

  onSelectChange = (id, event) => {
    const newQuestions = this.state.question;
    const index = this.state.question.answers.findIndex((x) => x.id === id);
    newQuestions.answers[index].order = parseInt(event.target.value, 10);
    this.setState({ question: newQuestions });
  };

  onChangeIncludeNotesInSuggestion = (question, value) => {
    this.props.updateIncludeNotesInSuggestion(question.id, value);
    this.setState({
      question: { ...question, includeNotesInSuggestion: value },
    });
  };

  isQuestionDisabled = (question, assignment, chapter) => {
    let isInAssignment = false;
    let isInCurrentAssignment = false;
    if (assignment?.disabledQuestions) {
      isInAssignment = _.pluck(assignment.disabledQuestions, 'id').includes(
        question.id,
      );
    }
    if (
      !assignment &&
      chapter &&
      chapter.assignments &&
      chapter.assignments.length
    ) {
      isInCurrentAssignment = true;
    }
    return (
      question.isPublished ||
      question.status === 'Deleted' ||
      isInAssignment ||
      isInCurrentAssignment ||
      question.deletedAt ||
      !this.props.editPermission
    );
  };

  setNoBorderRed = () => {
    const copyQuestion = this.getCopyOfObject(this.state.question);
    copyQuestion.redBorderC = false;
    copyQuestion.redBorderD = false;
    this.setState({ question: copyQuestion });
  };

  getAnswers = (question, assignment) => {
    const selectOptions = orderOptions.filter(
      (option) => !this.optionIsSelected(option),
    );
    const isDisabled = this.isQuestionDisabled(
      question,
      assignment,
      this.props.chapter,
    );
    const indexArray = [0, 1, 2];
    if (!Array.isArray(question.answers)) {
      question.answers = JSON.parse(question.answers);
      this.setState({ question });
    }
    const incorrectAnswers = question.answers
      .filter((a) => !a.correct)
      .sort((a, b) => a.id - b.id);
    let correctAnswer = question.answers.filter((a) => a.correct)[0];
    let maxId = 0;
    let aux = 0;
    question.answers.forEach((nAnswer) => {
      if (nAnswer) {
        aux = nAnswer.id;
        if (aux > maxId) {
          maxId = aux;
        }
      }
    });
    let plus = 1;
    if (!correctAnswer) {
      correctAnswer = {
        id: maxId + plus,
        correct: true,
        order: 0,
        text: '',
        wasAIGenerated: false,
        substantialChanges: false,
      };
      plus++;
      this.setState({ question });
      question.answers.push(correctAnswer);
    }
    indexArray.forEach((index) => {
      if (!incorrectAnswers[index]) {
        const answerTemplate = {
          id: maxId + plus,
          correct: false,
          order: 0,
          text: '',
        };
        question.answers.push(answerTemplate);
        incorrectAnswers.push(answerTemplate);
        plus++;
      }
    });
    incorrectAnswers.sort((a, b) => (a.id > b.id ? 1 : b.id > a.id ? -1 : 0));
    const optionLabels = ['A', 'B', 'C', 'D'];

    let answers = optionLabels.map((label, i) => {
      const isCorrect = label === 'A';
      const redBorder = this.state.question[`redBorder${label}`];
      const answerData = isCorrect ? correctAnswer : incorrectAnswers[i - 1];
      return (
        <>
          <AnswerTextArea
            title={`Option ${label}${isCorrect ? ' (Correct)' : ''}`}
            onChangeAnswer={(value) => {
              this.onChangeAnswer(value, answerData.id);
            }}
            onImagePaste={this.handleAnswerImagePasted(i)}
            value={answerData}
            showNoErrors
            selectOptions={selectOptions}
            onSelectChange={this.onSelectChange}
            redBorder={redBorder}
            contentErrors={answerData?.contentErrors}
            disabled={isDisabled}
            isCorrect={isCorrect}
            isFlashCardMode={this.state.isFlashCardMode}
            setNoBorderRed={this.setNoBorderRed}
            substantialChangeCheckbox={
              isCorrect ? this.substantialChangeCheckbox : undefined
            }
            originalResponse={question.originalResponse}
            isCreatingAiQuestion={this.props.isCreatingAiQuestion}
            question={isCorrect ? question : undefined}
            spellCheckOn={this.state.spellCheckOn}
          />
        </>
      );
    });

    // If in flashcard mode, remove incorrect answers
    if (this.state.isFlashCardMode) {
      answers = answers.slice(0, 1); // Only keep Option A
    }
    return answers;
  };

  renderImagesRow = (question) => {
    if (question?.audio) return null;

    const backgroundColor = this.props.isCreatingAiQuestion
      ? '#d9d0fa'
      : '#e4ecf9';
    const headerColor = this.props.isCreatingAiQuestion ? '#b8a6f0' : '#afc8f0';

    const answers = question.answers;
    const optionLabels = ['A', 'B', 'C', 'D'];

    const slots = [
      {
        key: 'question',
        label: 'Question',
        imageUrl: question.imageUrl,
        onUpload: (chapter) => {
          const q = Object.assign(this.state.question);
          q.fileImageUrl = chapter.pdf;
          question.imageUrl = chapter.pdf.name;
          this.setState({ question: q });
        },
        onDelete: () => {
          const q = Object.assign(this.state.question);
          q.imageUrl = null;
          delete q.fileImageUrl;
          this.setState({ question: q });
        },
      },
      ...optionLabels.map((label, i) => {
        const answer = answers[i];
        return {
          key: `answer-${label}`,
          label: `Answer ${label}`,
          imageUrl: answer?.imageUrl,
          onUpload: (chapter) => {
            const q = {
              ...this.state.question,
              answers: this.state.question.answers.map((ans) => ({ ...ans })),
            };
            if (q.answers[i]) {
              q[`fileImageUrlAnswer${i}`] = chapter.pdf;
              q.answers[i].imageUrl = chapter.pdf.name;
            }
            this.setState({ question: q });
          },
          onDelete: () => {
            const q = {
              ...this.state.question,
              answers: this.state.question.answers.map((ans) => ({ ...ans })),
            };
            if (q.answers[i]) {
              q.answers[i].imageUrl = null;
              delete q[`fileImageUrlAnswer${i}`];
            }
            this.setState({ question: q });
          },
        };
      }),
    ];
    const hasImages = slots.some((slot) => slot.imageUrl);

    return (
      <QuestionExtraInformation
        title="Images"
        backgroundColor={backgroundColor}
        headerColor={headerColor}
        body={
          <div className={`imagesRow${hasImages ? ' hasImages' : ''}`}>
            {slots.map((slot) => (
              <div className="imageSlot" key={slot.key}>
                <div className="imageSlotContent">
                  <UploadInput
                    editPermission={this.props.editPermission}
                    imageUrl={slot.imageUrl}
                    accept="image/x-png,image/gif,image/jpeg,image/jpg,image/webp"
                    chapter={{ id: slot.key }}
                    maxFileSize={500 * 1024}
                    deletePdfChapter={slot.onDelete}
                    updateQuestionPdfProcessing={() => {}}
                    questionPdfProcessing={false}
                    updateChapter={slot.onUpload}
                    className="questionImageUrl text imageSlotUpload"
                  />
                  {slot.imageUrl?.includes('http') && (
                    <div
                      onClick={(e) => e.stopPropagation()}
                      className="image-question-preview-container"
                    >
                      <ModalImage
                        small={`${slot.imageUrl}?t=${Date.now()}`}
                        large={`${slot.imageUrl}?t=${Date.now()}`}
                        className="image-question-preview"
                        hideDownload
                        hideZoom
                      />
                    </div>
                  )}
                </div>
                <span className="imageSlotLabel">{slot.label}</span>
              </div>
            ))}
          </div>
        }
      />
    );
  };

  handleQuestionImagePasted = (link) => {
    const q = Object.assign(this.state.question);
    q.imageUrl = link;
    this.setState({ question: q });
  };

  handleAnswerImagePasted = (index) => (link) => {
    const q = {
      ...this.state.question,
      answers: this.state.question.answers.map((ans) => ({ ...ans })),
    };
    if (q.answers[index]) {
      q.answers[index].imageUrl = link;
    }
    this.setState({ question: q });
  };

  getCopyOfObject = (object) => {
    const result = { ...object };
    return result;
  };

  getNonEmptyValue = (text, altText) => {
    if (text && text !== '' && typeof text !== undefined) {
      return text;
    }
    if (altText) {
      return altText;
    }
    return null;
  };

  changeQuestionMode = () => {
    const { question, isFlashCardMode } = this.state;
    const newQuestion = this.getCopyOfObject(question);

    // update the question mode
    newQuestion.flashQuestionNotes = newQuestion.notes;
    newQuestion.multipleOptionMode = isFlashCardMode;
    newQuestion.flashMode = !isFlashCardMode;

    this.setState({ isFlashCardMode: !isFlashCardMode, question: newQuestion });
  };

  showConfirmModal = () => {
    const isOptionDisabled =
      (this.state.question.multipleOptionMode && this.state.isFlashCardMode) ||
      (!this.state.question.multipleOptionMode && !this.state.isFlashCardMode);
    const hasSameQuestionText =
      this.state.question.flashQuestionText === this.state.question.text;

    if (isOptionDisabled && hasSameQuestionText) {
      this.props.openModal({
        modalTitle: 'Please confirm if the question text is correct',
        modalContent: (
          <SimpleConfirmation
            onConfirm={this.onSubmit}
            onCancel={this.props.closeModal}
            text={
              <div>
                The question text for the flash card mode and the multiple
                question mode is the same. Are you sure you want to continue?
              </div>
            }
          />
        ),
      });
    } else {
      this.onSubmit();
    }
  };

  onSubmit = () => {
    const questionToUpdate = { ...this.state.question };

    const correctAnswer = questionToUpdate.answers.find((a) => a.correct);

    // Trim all answer texts to remove leading/trailing spaces
    questionToUpdate.answers.forEach((answer) => {
      answer.text = (answer.text ?? '').trim();
    });

    if (questionToUpdate.flashQuestionNotes === null) {
      questionToUpdate.flashQuestionNotes = '';
    } else if (questionToUpdate.notes === null) {
      questionToUpdate.notes = '';
    }

    // Validate question text is not empty (unless it has an image)
    const questionText = this.state.isFlashCardMode
      ? questionToUpdate.flashQuestionText
      : questionToUpdate.text;
    const questionHasImage =
      questionToUpdate.imageUrl && questionToUpdate.imageUrl.trim().length > 0;
    const questionHasText = questionText && questionText.trim().length > 0;

    if (!questionHasText && !questionHasImage) {
      this.props.showWarning(
        'Input error!',
        'Question must have text or an image. Empty question without image is not allowed.',
      );
      return;
    }

    // Count valid answers (answers with text OR image)
    const validAnswers = questionToUpdate.answers.filter((answer) => {
      const hasText = answer.text && answer.text.length > 0;
      const hasImage = answer.imageUrl && answer.imageUrl.trim().length > 0;
      return hasText || hasImage;
    });

    // Validate minimum answers based on mode
    if (this.state.isFlashCardMode) {
      // Flashcard mode: needs exactly 1 valid answer (the correct one)
      if (validAnswers.length === 0) {
        this.props.showWarning(
          'Input error!',
          'The correct answer must have text or an image.',
        );
        return;
      }
    } else {
      // Multiple choice mode: needs at least 2 valid answers (1 correct + 1 incorrect)
      if (validAnswers.length < 2) {
        this.props.showWarning(
          'Input error!',
          'At least 2 answers are required (1 correct and 1 incorrect).',
        );
        return;
      }

      // Validate at least 1 valid correct answer
      const validCorrect = validAnswers.filter((answer) => answer.correct);
      if (validCorrect.length === 0) {
        this.props.showWarning(
          'Input error!',
          'The correct answer must have text or an image.',
        );
        return;
      }

      // Validate at least 1 valid incorrect answer
      const validIncorrect = validAnswers.filter((answer) => !answer.correct);
      if (validIncorrect.length === 0) {
        this.props.showWarning(
          'Input error!',
          'At least one incorrect answer with text or image is required.',
        );
        return;
      }
    }

    // Validate Further Reading character limit
    const furtherReading =
      questionToUpdate.notes || questionToUpdate.flashQuestionNotes;
    if (furtherReading && !validateCharacterLimit(furtherReading)) {
      this.props.showWarning(
        'Character limit exceeded',
        'Further Reading cannot exceed 1000 characters. Please reduce the content.',
      );
      return; // Prevent saving
    }

    if (correctAnswer.wasAIGenerated || this.props.isCreatingAiQuestion)
      correctAnswer.substantialChanges = this.state.substantialChangesAnswer;

    if (
      this.state.question &&
      this.state.flashMode &&
      !questionToUpdate.flashQuestionText
    ) {
      questionToUpdate.flashQuestionText =
        this.state.question.flashQuestionText;
    }
    questionToUpdate.isCreatingAiQuestion = this.props.isCreatingAiQuestion;
    if (this.props.isCreatingAiQuestion) {
      questionToUpdate.wasAIGenerated = true;
      const correctAns = questionToUpdate.answers.find((a) => a.correct);
      if (correctAns) correctAns.wasAIGenerated = true;
    }
    questionToUpdate.customPromptId = null;
    if (this.state.customPromptSelect && this.state.customPromptSelect.id) {
      questionToUpdate.customPromptId = this.state.customPromptSelect.id;
    } else if (
      this.state.userCustomPrompts &&
      this.props.userCustomPrompts.length
    ) {
      questionToUpdate.customPromptId = this.props.userCustomPrompts[0].id;
    }

    const incorrectAnswers = questionToUpdate.answers.filter((a) => !a.correct);
    let deleting = false;
    if (this.validate(questionToUpdate)) {
      if (correctAnswer && incorrectAnswers) {
        const indexArray = [3, 2, 1, 0];
        indexArray.forEach((i) => {
          if (questionToUpdate.answers[i]) {
            if (!this.isValidAnswerContent(questionToUpdate.answers[i])) {
              if (questionToUpdate.answers[i].updatedAt) deleting = true;
              questionToUpdate.answers.splice(i, 1);
            }
          }
        });
        const assignment = this.props.assignment
          ? this.props.assignment.id
          : null;
        if (this.state.isFlashCardMode) {
          indexArray.forEach((i) => {
            if (questionToUpdate.answers[i]) {
              if (!this.isValidAnswerContent(questionToUpdate.answers[i])) {
                if (questionToUpdate.answers[i].updatedAt) deleting = true;
                questionToUpdate.answers.splice(i, 1);
              }
            }
          });
        }
        if (!this.props.question) {
          if (!questionToUpdate.softwarePage) {
            delete questionToUpdate.softwarePage;
          }
          if (!questionToUpdate.documentPage) {
            delete questionToUpdate.documentPage;
          }
          questionToUpdate.chapter = this.props.chapter.id;
          questionToUpdate.multipleOptionMode = !this.state.isFlashCardMode;
          questionToUpdate.flashMode = this.state.isFlashCardMode;
          questionToUpdate.creationView = 'list';
          this.props.onCreateQuestion(questionToUpdate, assignment);
          if (this.state.question) {
            if (this.state.question.answers.length > 0) {
              this.state.question.answers.forEach((a) => {
                a.text = '';
              });
            }
          }
        } else {
          questionToUpdate.substantialChanges =
            this.state.substantialChangesQuestion;
          // questionToUpdate.aiquestion = JSON.stringify(
          //   questionToUpdate.aiquestion,
          // );
          this.props.onEditQuestion(questionToUpdate, assignment);
        }
      }
      // Show spell-check previews automatically after saving
      this.setState({ spellCheckOn: true });
      this.props.closeModal();
      if (deleting && correctAnswer) {
        deleting = false;
        this.refreshForm();
      }

      this.props.closeModal();
    } else {
      this.props.showWarning(
        'Input error!',
        'Please review the errors in the form',
      );
    }
  };

  isValidString = (text) => text && text !== '' && text.trim() !== '';

  // Check if answer has valid content (text OR imageUrl)
  isValidAnswerContent = (answer) => {
    const hasValidText = this.isValidString(answer.text);
    const hasValidImage = answer.imageUrl && answer.imageUrl.trim() !== '';
    return hasValidText || hasValidImage;
  };

  computeContentErrors = (question) => {
    const questionDisplayText = question.multipleOptionMode
      ? this.getNonEmptyValue(question.text, question.flashQuestionText)
      : this.getNonEmptyValue(question.flashQuestionText, question.text);
    question.redBorderQuestionMark = !endsWithQuestionMark(questionDisplayText);
    question.contentErrorsQuestion =
      getQuestionContentErrorMessages(questionDisplayText);

    const duplicateAnswers = getDuplicateAnswers(question.answers);
    (question.answers || []).forEach((answer) => {
      answer.contentErrors = getAnswerContentErrorMessages(
        answer,
        duplicateAnswers,
      );
    });

    question.contentErrorsNotes = getTextContentErrorMessages(question.notes);

    question.contentErrorsAiAdminFeedback = getTextContentErrorMessages(
      question.aiAdminFeedback,
    );

    return question;
  };

  validate = (question) => {
    const correctAnswer = question.answers.filter((a) => a.correct)[0];
    const incorrectAnswers = question.answers.filter((a) => !a.correct);
    incorrectAnswers.sort((a, b) => (a.id > b.id ? 1 : b.id > a.id ? -1 : 0));
    let incorrectWithContent = 0;
    let answerIncorrectWithContent;
    incorrectAnswers.forEach((e) => {
      if (this.isValidAnswerContent(e)) {
        incorrectWithContent++;
        answerIncorrectWithContent = e;
      }
    });
    question.redBorderB = false;
    if (this.state.isFlashCardMode) {
      question.redBorderText =
        !this.isValidString(question.flashQuestionText) ||
        getTextCharacterCount(question.flashQuestionText) > 1000;
      this.setState({ question });

      // Check if correct answer has text OR image
      const hasCorrect = !!(
        correctAnswer && this.isValidAnswerContent(correctAnswer)
      );
      question.redBorderA = !hasCorrect;
      return (
        !question.redBorderFlashQuestionText &&
        !question.redBorderText &&
        !question.redBorderA
      );
    }

    // For multiple choice mode, check if correct answer has text OR image
    const hasCorrect = !!(
      correctAnswer && this.isValidAnswerContent(correctAnswer)
    );
    question.redBorderA = !hasCorrect;

    // Check incorrect answers - need at least one with text OR image
    const hasOneIncorrect =
      incorrectAnswers && incorrectWithContent > 1
        ? true
        : !!(
            answerIncorrectWithContent &&
            this.isValidAnswerContent(answerIncorrectWithContent)
          );
    question.redBorderB = !hasOneIncorrect;
    question.redBorderText =
      !this.isValidString(question.text) ||
      getTextCharacterCount(question.text) > 1000;

    this.setState({ question });

    if (question.isCreatingAiQuestion && !question.customPromptId) {
      this.setState({
        errorCustom: true,
      });
      return false;
    }
    this.setState({
      errorCustom: false,
    });

    return (
      !question.redBorderFlashQuestionText &&
      !question.redBorderText &&
      !question.redBorderA &&
      !question.redBorderB /*
        (!question.redBorderB || !question.redBorderC || !question.redBorderD) */
    );
  };

  openQuestionPreview = () => {
    const question = this.state.question;

    // Prepare question data to pass to preview
    const questionData = {
      text: question.text,
      answers: question.answers?.map((a) => {
        delete a.imageBlob;
        return a;
      }),
      imageUrl: question.imageUrl,
      flashMode: question.flashMode,
      flashQuestionText: question.flashQuestionText,
      notes: question.notes,
    };

    // Encode the question data as URL parameters
    const encodedData = encodeURIComponent(JSON.stringify(questionData));
    const previewUrl = `${process.env.REACT_APP_BLUEJACKETEER_LINK.replace('/login', '/app')}/questionPreview?data=${encodedData}`;

    // Open in new tab
    window.open(previewUrl, '_blank', 'noopener,noreferrer');
  };

  getOptions = (selectedQuestion, isSubmitQuestion) => {
    let options = [];
    if (this.props.editPermission) {
      options.push({
        name: this.state.isFlashCardMode
          ? 'Convert to Multiple'
          : 'Convert to Flashcard',
        event: this.changeQuestionMode,
      });
      if (!isSubmitQuestion) {
        if (selectedQuestion) {
          if (!selectedQuestion.isPublished) {
            if (this.props.assignment) {
              const assignment = this.getCopyOfObject(this.props.assignment);
              assignment.disabledQuestions = _.pluck(
                assignment.disabledQuestions,
                'id',
              );
              const isDisabled = assignment.disabledQuestions.includes(
                selectedQuestion.id,
              );
              if (isDisabled) {
                assignment.disabledQuestions =
                  assignment.disabledQuestions.filter(
                    (q) => q !== selectedQuestion.id,
                  );
                if (selectedQuestion.sourceQuestion) {
                  assignment.disabledQuestions =
                    assignment.disabledQuestions.filter(
                      (q) => q !== selectedQuestion.sourceQuestion,
                    );
                }
              } else {
                assignment.disabledQuestions.push(selectedQuestion.id);
                if (selectedQuestion.sourceQuestion) {
                  assignment.disabledQuestions.push(
                    selectedQuestion.sourceQuestion,
                  );
                }
              }
              options = options.concat([
                {
                  name: isDisabled ? 'Enable' : 'Disable',
                  event: () =>
                    this.props.onEditAssignment(
                      _.pick(assignment, 'disabledQuestions', 'id', 'status'),
                    ),
                },
              ]);
            }
            if (selectedQuestion.sourceQuestion) {
              options.push({
                name: 'View Live Question',
                event: () =>
                  this.props.loadPublishedQuestion(
                    this.state.question.sourceQuestion,
                  ),
              });
            }
          } else {
            options = [
              {
                name: 'View Editing Question',
                event: () => this.props.loadPublishedQuestion(null),
              },
            ];
          }
        }

        options.push({
          name: 'Check spelling',
          event: () => this.setState({ spellCheckOn: true }),
        });
        options.push({
          name: 'Question history',
          event: () => {
            this.props.getQuestionHistory(this.state.question.id);
          },
        });
        options.push({
          name: 'Delete Question',
          event: () =>
            this.props.deleteQuestion(
              [this.state.question],
              this.props.assignment ? this.props.assignment.id : null,
            ),
        });
      }
    }
    return options;
  };

  substantialChangeCheckbox = (isQuestion) => (
    <Row className={`ImageRow mt-2 mb-2 ${!isQuestion ? 'pl-3 mt-3' : null}`}>
      <input
        type="checkbox"
        htmlFor="substantialChanges"
        value={
          isQuestion
            ? this.state.substantialChangesQuestion
            : this.state.substantialChangesAnswer
        }
        onChange={(e) => {
          if (isQuestion)
            this.setState({
              substantialChangesQuestion:
                !this.state.substantialChangesQuestion,
            });
          if (!isQuestion) {
            this.setState({
              substantialChangesAnswer: !this.state.substantialChangesAnswer,
            });
          }
        }}
        id={
          isQuestion
            ? 'substantialCheckboxQuestion'
            : 'substantialCheckboxAnswer'
        }
        checked={
          isQuestion
            ? this.state.substantialChangesQuestion
            : this.state.substantialChangesAnswer
        }
      />
      <label
        className="mb-0"
        htmlFor={
          isQuestion
            ? 'substantialCheckboxQuestion'
            : 'substantialCheckboxAnswer'
        }
      >
        {`Substantial Changes Made to AI Generated ${
          isQuestion ? ' Question' : 'Answer'
        }`}
      </label>
    </Row>
  );

  getQuestionTitle = (question) => {
    if (question.sourceQuestion || question.status === 'New') {
      return (
        <span style={{ whiteSpace: 'pre-line' }}>
          {question.id ? `Question:\n${question.id}` : 'Question'}
          <i
            className="fa fa-circle"
            style={{ fontSize: '10px', marginLeft: '5px', color: '#0562ff' }}
          />
        </span>
      );
    }
    return question.id ? `Question:\n${question.id}` : 'Question';
  };

  getQuestionHistory = (question) => {
    let createdBy = '';
    if (question.createdBy) {
      createdBy = `Created by:\n${question.createdBy}`;
    }
    let subbmitedBy = '';
    if (question.submittedBy) {
      subbmitedBy = `Submitted by:\n${question.submittedBy}`;
    }
    return { createdBy, subbmitedBy };
  };

  getCreationQuestionDate = (question) => {
    const date = new Date(Number(question.createdAt));

    const formattedDate = date.toLocaleDateString(localeDateName, dateOptions);
    const formattedTime = date.toLocaleTimeString(localeDateName, timeOptions);

    const formattedDateTime = question.createdAt
      ? `Created on:\n${formattedDate} ${formattedTime}`
      : '';
    return formattedDateTime;
  };

  getImportInformation = (question) => {
    if (!question.importedFromProject && !question.OriginalProjectQuestionId) {
      return null;
    }

    const parts = [];

    if (question.importedFromProject) {
      parts.push(`Imported from:\n${question.importedFromProject}`);
    }

    if (question.originalProjectQuestionId) {
      parts.push(`Original Q#: ${question.originalProjectQuestionId}`);
    }

    return parts.join(' | ');
  };

  onSelect = (event) => {
    let selectPrompt;
    const { userCustomPrompts } = this.state;
    const selectedIndex = userCustomPrompts.findIndex(
      (item) => item.prompt.replace('USER_PROMPT ', '') === event,
    );

    userCustomPrompts.forEach((item) => {
      if (item.prompt.replace('USER_PROMPT ', '') === event) {
        selectPrompt = item;
      }
    });

    // Here the selected item is moved to the first position
    if (selectedIndex > 0) {
      const selectedPrompt = userCustomPrompts.splice(selectedIndex, 1);
      userCustomPrompts.unshift(selectedPrompt[0]);
    }
    this.setState({
      customText: event,
      addCustom: !this.state.addCustom,
      customPromptSelect: selectPrompt,
      errorCustom: false,
      userCustomPrompts,
      createCustom: false,
    });
  };

  handleCreateUserCustomPrompt() {
    if (!this.state.customText) {
      this.setState({
        errorCustom: true,
      });
    } else {
      const { userCustomPrompts } = this.state;
      let newArray = [];
      if (userCustomPrompts && userCustomPrompts.length) {
        newArray = [{ prompt: this.state.customText }, ...userCustomPrompts];
      } else {
        newArray.push({ prompt: this.state.customText });
      }
      this.setState({
        userCustomPrompts: newArray,
        customPromptSelect: this.state.customText,
        createCustom: false,
        addCustom: false,
      });
    }

    this.props.createUserCustomPrompt(
      this.state.customText,
      this.props.chapter.id,
    );
  }

  handleChangeCustom() {
    if (!this.state.addCustom) {
      this.setState({ customText: '' });
    }
    this.setState({ addCustom: !this.state.addCustom });
  }

  handlePrompt(event) {
    let existPrompt = true;

    if (this.state.userCustomPrompts && this.state.userCustomPrompts.length) {
      this.state.userCustomPrompts.forEach((item) => {
        if (item.prompt === event) {
          existPrompt = false;
        }
      });
    }
    this.setState({ customText: event, createCustom: existPrompt });
  }

  showSuggestionValidation() {
    const question = this.state.question;
    if (!question?.text || !question?.aiSuggestion) {
      return false;
    }
    return true;
  }

  onChangeAiAdminFeedback = (content) => {
    const question = this.state.question;
    question.aiAdminFeedback = content;
    this.setState({ question });
  };

  onClickFeedbackTemplate = (templateText) => {
    const current = this.state.question.aiAdminFeedback || '';
    const newValue = current + templateText;
    this.onChangeAiAdminFeedback(newValue);
  };

  render() {
    const { isFlashCardMode } = this.state;
    let question = this.state.question;
    if (this.props.publishedQuestion.id) {
      question = this.props.publishedQuestion;
      question.isPublished = true;
    }
    this.computeContentErrors(question);
    const isDisabled = this.isQuestionDisabled(
      question,
      this.props.assignment,
      this.props.chapter,
    );
    const showSoftwarePageButton =
      question.softwarePage && this.props.goToPdfPage;
    const backgroundColor = this.props.isCreatingAiQuestion
      ? '#cbc0f9'
      : '#f0f3f5';

    const isLoadingSuggestionInBackground =
      this.state.question?.aiSuggestionStatus === AI_TASK_STATUS.IN_PROGRESS;

    const hasAnyImage = Boolean(
      this.props.question?.imageUrl ||
      this.props.question?.answers?.some((answer) => answer?.imageUrl),
    );

    return (
      <Col
        md={9}
        style={{
          background: backgroundColor,
        }}
        className="form-column QuestionDetailsContainer"
      >
        <div className="mt-3 ml-3 mb-2 d-flex justify-content-between align-items-center">
          <div>
            <span>
              {question.originalResponse?.ai_question
                ? 'Edit AI question'
                : 'Create AI question'}
            </span>
            <label
              className="switch switch-3d switch-primary ml-2 mt-1"
              style={{ width: 25, height: 15 }}
            >
              <input
                type="checkbox"
                className="switch-input"
                checked={this.props.isCreatingAiQuestion}
                onChange={() => {
                  this.props.setIsCreatingAiQuestion(
                    !this.props.isCreatingAiQuestion,
                  );
                }}
              />
              <span className="switch-label" />
              <span
                className="switch-handle"
                style={{ height: 15, width: 15 }}
              />
            </label>
            <Button
              className="ml-4"
              color="info"
              size="sm"
              onClick={this.openQuestionPreview}
              style={{ fontSize: '13px' }}
            >
              <i className="fa fa-eye mr-1" />
              Preview
            </Button>
          </div>

          <Row className="dotsRow">
            <div className="mr-1">
              <DropDown
                data-test="question-options-dropdown"
                options={this.getOptions(question /* , question.submit */)}
                shouldCloseAfter
                style={{
                  position: 'absolute',
                  right: '5px',
                  zIndex: '5',
                }}
              />
            </div>
          </Row>
        </div>

        {/* Modal Question history */}
        {this.props.showModalHistoryQuestion === true && (
          <QuestionHistoryModal
            showModal={this.props.showModalHistoryQuestion}
            questionHistory={this.props.questionHistory}
            setShowModalQuestionHistory={this.props.setShowModalQuestionHistory}
          />
        )}
        {/* Question input section */}
        <QuestionTextArea
          title={this.getQuestionTitle(question)}
          onChangeQuestion={this.onChangeQuestion}
          onImagePaste={this.handleQuestionImagePasted}
          value={!isFlashCardMode ? question.text : question.flashQuestionText}
          redBorder={question.redBorderText}
          contentErrors={question.contentErrorsQuestion}
          disabled={isDisabled}
          sourceQuestion={question.sourceQuestion}
          loadPublishedQuestion={this.props.loadPublishedQuestion}
          selectedQuestion={question}
          questionHistory={this.getQuestionHistory(question)}
          creationQuestionDate={this.getCreationQuestionDate(question)}
          importInformation={this.getImportInformation(question)}
          improveQuestionWithAi={this.props.improveQuestionWithAi}
          onChangeIncludeNotesInSuggestion={
            this.onChangeIncludeNotesInSuggestion
          }
          isSaveQuestion={this.props.isSaveQuestion}
          isCreatingAiQuestion={this.props.isCreatingAiQuestion}
        />
        {/* quote characters / missing question mark */}
        {!question.redBorderText && (
          <Col md={12}>
            <ContentIssues
              messages={question.contentErrorsQuestion}
              label={getContentIssuesLabel('question')}
            />
          </Col>
        )}
        {this.state.spellCheckOn && (
          <Col md={12}>
            <SpellCheckPreview
              value={
                !isFlashCardMode ? question.text : question.flashQuestionText
              }
              showNoErrors
            />
          </Col>
        )}
        {(question.wasAIGenerated || this.props.isCreatingAiQuestion) &&
          this.substantialChangeCheckbox(true)}

        {/* No empty question validation */}
        {question.redBorderText &&
          getTextCharacterCount(question.text) === 0 && (
            <span className="redTextQuestion">
              You must fill in the question.
            </span>
          )}

        {/* not exceed 1000 characters question validation */}
        {question.redBorderText &&
          getTextCharacterCount(question.text) > 1000 && (
            <span className="redTextQuestion">
              Question should not exceed 1000 characters.
            </span>
          )}

        <div />

        {/* Ai original question section */}
        {((this.props.isCreatingAiQuestion && question.text.length > 0) ||
          question.originalResponse?.ai_question) && (
          <QuestionExtraInformation
            title="Original AI Question"
            backgroundColor={
              question.substantialChanges ? '#fce9ccb9 ' : '#f3f1ff'
            }
            headerColor={
              this.props.isCreatingAiQuestion
                ? '#ab9dfaff'
                : question.substantialChanges
                  ? '#ffb889e0'
                  : '#c6bef4'
            }
            body={
              <div
                className="text"
                dangerouslySetInnerHTML={{
                  __html: sanitizeRichText(
                    this.props.isCreatingAiQuestion &&
                      !question.originalResponse?.ai_question
                      ? question.text
                      : question.originalResponse?.ai_question,
                  ),
                }}
              />
            }
          />
        )}
        {/* Ai suggestion question section */}
        {(this.showSuggestionValidation() ||
          isLoadingSuggestionInBackground) && (
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <QuestionExtraInformation
              title="AI Suggestion"
              backgroundColor="#f2d9f266"
              headerColor="#ff80ff59"
              body={
                isLoadingSuggestionInBackground ? (
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'left',
                      alignItems: 'center',
                    }}
                  >
                    <i className="fa fa-lightbulb-o" />
                    <span className="ml-2 text">
                      {`Preparing suggestion for question ${question.id}`}
                    </span>
                    <Spinner style={{ width: '50px' }} color="#222" />
                  </div>
                ) : (
                  this.showSuggestionValidation() && (
                    <>
                      <i className="fa fa-lightbulb-o" />
                      <span className="ml-2 text">{question.aiSuggestion}</span>
                    </>
                  )
                )
              }
            />
          </div>
        )}
        {/* Ai agent question section */}
        {this.props.question?.wasAIGenerated &&
          this.props.question?.aiquestion && (
            <QuestionExtraInformation
              title="AI Student Agent Answer"
              backgroundColor="#e6f5e2" /* antes: #dff0d8 */
              headerColor="#8adf8ab3" /* antes: #4abf4ab3 */
              body={
                <StudentAgentAnswer
                  aiquestion={this.props.question.aiquestion}
                />
              }
            />
          )}
        {/* Question input section */}
        {this.renderImagesRow(question)}
        {/* Audio question section */}
        {this.props.question?.id &&
          (this.props.question?.audio || !hasAnyImage) && (
            <QuestionExtraInformation
              title="Question Audio"
              backgroundColor="#e4ecf9"
              headerColor="#afc8f0"
              body={<QuestionAudioActions />}
            />
          )}
        {/* Answers section */}
        {this.getAnswers(this.state.question, this.props.assignment)}
        {/* Pages input section */}
        <Row className="QuestionTextAreaContainer">
          <Col md={6} className="wysiwyng-title">
            Further Reading
          </Col>
          <Col md={6} className="flexEnd">
            Document Page
            <input
              name="documentPage"
              data-test="question-document-page-input"
              value={question.documentPage ?? ''}
              onChange={this.onChangePageNumber}
              disabled={isDisabled}
              className="SmallInput BorderTextArea MarginRight15 form-control"
            />
            {!showSoftwarePageButton ? (
              'Software Page'
            ) : (
              <span
                className="SpanLink"
                onClick={() => {
                  this.props.goToPdfPage(question.softwarePage);
                  this.props.setCurrentPage(question.softwarePage);
                }}
              >
                Software Page
              </span>
            )}
            <input
              name="softwarePage"
              data-test="question-software-page-input"
              value={question.softwarePage ?? ''}
              onChange={this.onChangePageNumber}
              disabled={isDisabled}
              className="SmallInput BorderTextArea form-control"
              type="number"
            />
          </Col>
        </Row>
        {/* Further reading section */}
        <Col md={12}>
          <div className="wysiwyg-further-reading-container">
            <WYSIWYG
              onChange={this.onChangeFurtherReading}
              redBorder={this.props.redBorder}
              contentError={(question.contentErrorsNotes || []).length > 0}
              value={question.notes}
              updateEditorView={question.updateEditorView}
              disabled={isDisabled}
              showWarning={this.props.showWarning}
            />
            <ContentIssues
              messages={question.contentErrorsNotes}
              label={getContentIssuesLabel('further reading')}
            />

            {/* Character counter */}
            {(question.notes || question.flashQuestionNotes) &&
              (() => {
                const furtherReading =
                  question.notes || question.flashQuestionNotes;
                const { count, isValid } = getCharacterStatus(furtherReading);
                const isOverLimit = !isValid;

                return (
                  <div
                    className={`character-counter ${isOverLimit ? 'over-limit' : ''}`}
                  >
                    <span>Characters: </span>
                    <span className="character-counter-number">{count}</span>
                    <span> / 1000</span>
                  </div>
                );
              })()}
          </div>
          {this.state.spellCheckOn && (
            <SpellCheckPreview value={question.notes} showNoErrors />
          )}
        </Col>
        {/* AI Admin Feedback section */}
        <Col md={12} className="mt-3">
          <label htmlFor="ai-admin-feedback" className="wysiwyng-title">
            Admin Feedback on AI Question
          </label>
          <WYSIWYG
            id="ai-admin-feedback"
            isInput
            onChange={this.onChangeAiAdminFeedback}
            redBorder={this.props.redBorderText}
            contentError={
              (question.contentErrorsAiAdminFeedback || []).length > 0
            }
            value={question.aiAdminFeedback}
            updateEditorView={question.updateEditorView}
            disabled={isDisabled}
            allowedFormats={[['bold', 'underline']]}
          />
          <ContentIssues
            messages={question.contentErrorsAiAdminFeedback}
            label={getContentIssuesLabel('AI feedback')}
          />
          {this.state.spellCheckOn && (
            <SpellCheckPreview value={question.aiAdminFeedback} showNoErrors />
          )}
          {this.props.aiFeedbackTemplates?.length > 0 && (
            <div className="mt-2">
              <span className="wysiwyng-title">Common AI Feedback</span>
              <div className="ai-feedback-templates-container">
                {this.props.aiFeedbackTemplates.map((template, index) => (
                  <button
                    key={index}
                    type="button"
                    className="ai-feedback-pill"
                    disabled={isDisabled}
                    onClick={() => this.onClickFeedbackTemplate(template)}
                  >
                    {template}
                  </button>
                ))}
              </div>
            </div>
          )}
        </Col>
        {/* AI Custom Prompt section */}
        {this.props.isCreatingAiQuestion && (
          <Col md={12} className="mt-3">
            <span>Custom Prompt</span>
            {this.state.errorCustom && (
              <span style={{ color: 'red' }} className="ml-1">
                required
              </span>
            )}

            <div className="mt-3">
              <div>
                {!this.state.addCustom ? (
                  <select
                    value={this.state.customPrompt}
                    className="form-control mb-2"
                    onChange={(e) => {
                      this.onSelect(e.target.value);
                    }}
                  >
                    {this.state.userCustomPrompts?.map((p, index) => (
                      <option
                        key={index}
                        value={p.prompt.replace('USER_PROMPT ', '')}
                      >
                        {' '}
                        {p.prompt.replace('USER_PROMPT ', '').length > 70
                          ? `${p.prompt
                              .replace('USER_PROMPT ', '')
                              .substring(0, 70)}...`
                          : p.prompt.replace('USER_PROMPT ', '')}
                      </option>
                    ))}
                  </select>
                ) : (
                  <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <textarea
                      type="text"
                      value={this.state.customText}
                      disabled={false}
                      style={{
                        width: '100%',
                        border: this.state.errorCustom ? '1px solid red' : null,
                      }}
                      onChange={(e) => {
                        this.handlePrompt(e.target.value);
                      }}
                    />
                    {this.state.createCustom && (
                      <div style={{ display: 'flex', flexDirection: 'row' }}>
                        <div className="check">
                          <i
                            className="fa fa-check fa-lg"
                            style={{ cursor: 'pointer' }}
                            onClick={() => this.handleCreateUserCustomPrompt()}
                          />
                        </div>
                        <div className="cross">
                          <i
                            className="fa fa-close fa-lg"
                            style={{ cursor: 'pointer' }}
                            onClick={() =>
                              this.setState({
                                addCustom: !this.state.addCustom,
                              })
                            }
                          />
                        </div>
                      </div>
                    )}
                  </div>
                )}
                <div>
                  <Button
                    className="btn btn-info mt-2 marginLeft"
                    onClick={() => this.handleChangeCustom()}
                  >
                    {' '}
                    {this.state.addCustom ? 'Select Custom' : 'Add Custom'}
                  </Button>
                </div>
              </div>
            </div>
          </Col>
        )}
        <div style={{ marginBottom: '250px' }} />
        <Footer backgroundColor={backgroundColor} />
        <NotificationSystem ref="notificationSystem" />
      </Col>
    );
  }
}

QuestionDetails.defaultProps = {
  defaultQuestion: {
    notes: '',
    softwarePage: null,
    documentPage: null,
    text: '',
    updateEditorView: true,
    answers: [
      { correct: true, order: 0, text: '', id: 1 },
      { correct: false, order: 0, text: '', id: 2 },
      { correct: false, order: 0, text: '', id: 3 },
      { correct: false, order: 0, text: '', id: 4 },
    ],
    multipleOptionMode: true,
    flashMode: false,
    defaultQuestion: true,
  },
  defaultFlaschardQuestion: {
    softwarePage: null,
    documentPage: null,
    flashQuestionText: '',
    flashMode: true,
    updateEditorView: true,
    multipleOptionMode: false,
    answers: [
      { correct: true, order: 0, text: '', id: 1 },
      { correct: false, order: 0, text: '', id: 2 },
      { correct: false, order: 0, text: '', id: 3 },
      { correct: false, order: 0, text: '', id: 4 },
    ],
    defaultQuestion: true,
  },
};
